import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '@admin/models';

@Injectable({ providedIn: 'root' })
export class UserApiService {
  constructor(private http: HttpClient) {}

  getUserDetails(): Observable<{ data: User; status: string; message?: string }> {
    return this.http.get<{ data: User; status: string; message?: string }>('auth/api/user-details');
  }

  fetchCountryIds(regionCodes: string[]): Observable<{ status: string; message: string }> {
    return this.http.get<{ status: string; message: string }>(
      `vehicles/api/fetchCountyIdByRegionCodes?regionCodes=${regionCodes.join(',')}`,
    );
  }
}
